import { useState, useEffect, useCallback } from "react";
import { useWindowSize } from "../../../hooks/useWindowSize";
import Modal from "react-bootstrap/Modal";
// import { DatePickerField } from "../../../shared/_helpers/datepicker";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AlertMsg } from "../../../shared/components/alert-msg";
import "react-datepicker/dist/react-datepicker.css";
import { TableComponent } from "../../../shared/components/table";
import PP from "../../../assets/pp.svg";
import Chat from "../../../assets/chat.svg";
import CallNow from "../../../assets/call.svg";
import { LoadingItem } from "../../../shared/components/loading";
import { getDateFromISO, numberWithCommas } from "../../../shared/utils";
import ReactPaginate from "react-paginate";
import { useDebounce } from "use-debounce";
import FilterModal from "./FilterModal";
import { Order } from "../../../types/OrderTypes";
import { Button } from "react-bootstrap";
import OrderConfirmationModal from "./OrderConfirmationModal";
import OrderCancelModal from "./OrderCancelModal";
import { FiTrash2 } from "react-icons/fi";
import CustomPagination from "../../../shared/components/pagination/CustomPagination";
import { LoadOrderInfo } from "./LoadOrderInfo";




const getStoreOrders = async ({ pageProps, payload }: any) => {
  await pageProps.getStoreOrders(payload);
};

const getStoreOrderDetails = async ({ pageProps, payload }: any) => {
  await pageProps.getStoreOrderDetails(payload);
};
const changeOrderStatusAction = async ({
  pageProps,
  payload,
  type,
  callback,
}: any) => {
  await pageProps.changeOrderStatus(payload, type, callback);
};

export const InAppContent = ({ pageProps }: any) => {
  const [startDate, onStartChange] = useState<any>();
  const [endDate, onEndChange] = useState<any>();
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);

  const [showOrderInfo, setShowOrderInfo] = useState(false);
  const [deliveryInfo, setDeliveryInfo] = useState<any>();
  const [chosenOrder, setChosenOrder] = useState<any>();
  const screenResolution: any = useWindowSize();

  const [currentPage, setCurrentPage] = useState(1);

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page") as string) || 1;

  const [pageNumber, setPageNumber] = useState(initialPage);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", pageNumber.toString());
    navigate(`?${params.toString()}`, { replace: true });
  }, [pageNumber, location.search, navigate]);

  const [pageSize, setPageSize] = useState(10);
  const [fetchPayload, setFetchPayload] = useState<any>();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [activeFilters, setActiveFilters] = useState<any>(null);

  const [filterValues, setFilterValues] = useState({
    selectedStatuses: [],
    fromDate: "",
    toDate: "",
    minTotal: "0",
    maxTotal: "1000",
  });

  const ReportTable = ({ reportData }: any) => {
    let orderList: Order[] = reportData?.results;
    if (orderList.length >= 1) {
      return (
        <>
          <thead>
            <tr>
              <th>
                <span>Order ID</span>
              </th>
              <th>
                {" "}
                <span>Order Date</span>
              </th>
              <th>Status</th>
              <th>Subtotal</th>

              <th>
                {" "}
                <span>Order Information</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {orderList.map((eachItem: any, index: any) => {
              return (
                <tr key={index}>
                  <td>#{eachItem.number}</td>
                  <td>
                    <div className="date-item">
                      {getDateFromISO({
                        date: eachItem.createdDate,
                        returnTime: true,
                      }) || "N/A"}
                    </div>
                  </td>
                  <td>
                    {eachItem.status !== "Successful" &&
                      eachItem.status !== "Failed" &&
                      eachItem.status !== "Cancelled" &&
                      eachItem.status !== "SuccessfulPendingCapture" && (
                        <span className="order-status others">
                          {eachItem.status}
                        </span>
                      )}
                    {eachItem.status == "SuccessfulPendingCapture" && (
                      <span className="order-status waiting">Pending</span>
                    )}
                    {eachItem.status === "Failed" && (
                      <span className="order-status failed">Failed</span>
                    )}
                    {eachItem.status === "Successful" && (
                      <span className="order-status done">Successful</span>
                    )}
                    {eachItem.status === "Cancelled" && (
                      <span className="order-status failed">Cancelled</span>
                    )}
                  </td>
                  <td>${eachItem.subtotal}</td>
                  <td>
                    <div className="view-order">
                      {eachItem.deliveryStatus === "UnProcessed" && (
                        <span
                          className="confirm_cta"
                          onClick={() => {
                            getStoreOrderDetails({
                              pageProps,
                              payload: "CLEAR",
                            });
                            changeOrderStatusAction({
                              pageProps,
                              payload: "CLEAR",
                            });
                            setChosenOrder(eachItem);
                            setShowOrderInfo(true);
                          }}
                        >
                          Confirm Order
                        </span>
                      )}
                      {eachItem.deliveryStatus !== "UnProcessed" && (
                        <Link to={`/app/my-orders/${eachItem.id}`}>
                          See details
                        </Link>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </>
      );
    } else {
      <div className="order-wrap">
        <div className="order-items-list">
          <div className="all_products">Order details unavailable</div>
        </div>
      </div>;
    }

    return <></>;
  };

  const MobileDataGrid = ({ reportData }: any) => {
    let orderList: any[] = reportData?.results;
    if (orderList.length >= 1) {
      return (
        <div className="mobile-data-grid for_orders">
          {orderList.length >= 1 && (
            <>
              {orderList.map((eachItem: any, index: any) => {
                return (
                  <div className="each_data_item" key={index}>
                    {/* <div className="top-tiny-txt">{getDateFromISO({ date: eachItem.createdDate, returnTime: true }) || "N/A"} </div> */}
                    <div className="main-txt-head for_orders">
                      <div className="order_id_action">
                        <div className="id_txt">
                          Order ID: {eachItem?.number}
                        </div>
                        <div className="order_cta">
                          {eachItem.status === "SuccessfulPendingCapture" && (
                            <span
                              className="order_action confirm"
                              onClick={() => {
                                getStoreOrderDetails({
                                  pageProps,
                                  payload: "CLEAR",
                                });
                                changeOrderStatusAction({
                                  pageProps,
                                  payload: "CLEAR",
                                });
                                setChosenOrder(eachItem);
                                setShowOrderInfo(true);
                              }}
                            >
                              Confirm Order
                            </span>
                          )}
                          {eachItem.status !== "SuccessfulPendingCapture" && (
                            <Link
                              className="order_action got_to"
                              to={`/app/my-orders/${eachItem.id}`}
                            >
                              See details
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="each_mobile_prod_info">
                      <div className="title-txt">Order date</div>
                      <div className="availables">
                        {" "}
                        {getDateFromISO({
                          date: eachItem.createdDate,
                          returnTime: true,
                        }) || "N/A"}{" "}
                      </div>
                    </div>
                    <div className="each_mobile_prod_info">
                      <div className="title-txt">Subtotal</div>
                      <div className="availables"> ${eachItem.subtotal} </div>
                    </div>
                    <div className="each_mobile_prod_info">
                      <div className="title-txt">Order status</div>
                      <div className="availables">
                        {" "}
                        {eachItem.status !== "SuccessfulPendingCapture"
                          ? `${eachItem.status}`
                          : "Pending"}{" "}
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      );
    } else {
      <div className="order-wrap">
        <div className="order-items-list">
          <div className="all_products">Order details unavailable</div>
        </div>
      </div>;
    }
    return <></>;
  };

  const handlePageClick = (event: any) => {
    setPageNumber(event?.selected + 1);
  };

  const handleFilterSearch = useCallback(
    (filters: {
      status: string[];
      fromDate: string;
      toDate: string;
      minTotal: number;
      maxTotal: number;
    }) => {
      let query = `Page=${pageNumber}&Size=${pageSize}&IsVendor=true`;

      if (
        filters.status &&
        filters.status.length > 0 &&
        !filters.status.includes("All")
      ) {
        const statusParams = filters.status
          .map((s) => `Statuses=${encodeURIComponent(s)}`)
          .join("&");
        query += `&${statusParams}`;
      }

      if (filters.fromDate) {
        query += `&FromDate=${encodeURIComponent(filters.fromDate)}`;
      }

      if (filters.toDate) {
        query += `&ToDate=${encodeURIComponent(filters.toDate)}`;
      }

      if (!isNaN(filters.minTotal)) {
        query += `&MinSubtotal=${filters.minTotal}`;
      }

      if (!isNaN(filters.maxTotal)) {
        query += `&MaxSubtotal=${filters.maxTotal}`;
      }

      getStoreOrders({ pageProps, payload: query });
    },
    [pageNumber, pageSize, pageProps]
  );

  useEffect(() => {
    if (activeFilters) {
      handleFilterSearch(activeFilters);
    } else {
      let payload = `Page=${pageNumber}&Size=${pageSize}`;
      getStoreOrders({ pageProps, payload });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, pageSize, activeFilters]);

  return (
    <div className="inapp-content">
      <Modal
        className="address_modal_wrap"
        show={showDeliveryModal}
        onHide={() => setShowDeliveryModal(false)}
      >
        <Modal.Header closeButton>
          {/* <div className="reason_heading">Reason for return </div> */}
        </Modal.Header>
        <Modal.Body>
          <div className="customer-info">
            <div className="customer-avatar">
              <img src={PP} alt="" />
            </div>
            <div className="customer-details">
              <div className="customer-name">{deliveryInfo?.customerName}</div>
              <div className="customer-email">
                {deliveryInfo?.customerEmail}
              </div>
              <div className="inbox-cta">
                <button type="button">
                  <img src={Chat} alt="" />
                  <span>Message Customer</span>
                </button>
              </div>
              <div className="call-cta">
                <button type="button">
                  <img src={CallNow} alt="" />{" "}
                  <span>{deliveryInfo?.customerPhone}</span>
                </button>
              </div>
            </div>
          </div>
          <div className="customer-address">
            <h3>Delivery Address</h3>
            {deliveryInfo?.customerAddress}
          </div>
        </Modal.Body>
      </Modal>
      {showOrderInfo && chosenOrder && (
        <LoadOrderInfo
          pageProps={pageProps}
          showOrderInfo={showOrderInfo}
          setShowOrderInfo={setShowOrderInfo}
          chosenOrder={chosenOrder}
          fetchPayload={fetchPayload}
        />
      )}
      <div className="page-content lists-wrap cards with-heading order-wrap">
        <div className="orders-header">
          {screenResolution?.width >= 769 && <h3>Orders</h3>}
          {screenResolution?.width <= 768 && <h3>Order Information</h3>}
          <div className="orders-txt">
            Manage all of your customer orders in one place.
          </div>
        </div>
        <div className="right-align">
          <span className="filter-label">Filter</span>
          <button
            className="filter-icon-button"
            onClick={() => {
              if (!showFilterModal) setShowFilterModal(true);
            }}
            type="button"
          >
            <svg
              className="filter-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#00C48C"
              // strokeWidth="2"
              // strokeLinecap="round"
              // strokeLinejoin="round"
            >
              <path
                d="M3 4h18l-7 8v5l-4 3v-8l-7-8z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="list-contanier">
          <div className="list-content-wrap  products-list">
            {pageProps.getStoreOrdersRequest.request_status ===
              "GET_VENDOR_ORDERS_PENDING" && <LoadingItem />}
            {pageProps.getStoreOrdersRequest.request_status ===
              "GET_VENDOR_ORDERS_SUCCESS" && (
              <div>
                <div className="all-items">
                  {/* <div className="sub-headings">
                                        <div className="each-menu">
                                            <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/my-orders">
                                                Ordered Products
                                                <span className="underline"></span>
                                            </NavLink>
                                        </div>
                                        <div className="each-menu">
                                            <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/my-orders/cancelled">
                                                Cancelled Orders
                                            </NavLink>
                                        </div>
                                    </div> */}

                  <div className="all-items-list">
                    {screenResolution?.width >= 768 && (
                      <TableComponent
                        childComponent={
                          <ReportTable
                            reportData={
                              pageProps.getStoreOrdersRequest.request_data
                                ?.response
                            }
                          />
                        }
                      />
                    )}
                    {screenResolution?.width <= 767 &&
                      pageProps?.getStoreOrdersRequest?.request_data
                        ?.response && (
                        <MobileDataGrid
                          reportData={
                            pageProps.getStoreOrdersRequest.request_data
                              ?.response
                          }
                        />
                      )}

                    {pageProps?.getStoreOrdersRequest?.request_data?.response
                      ?.totalNumberOfRecords > pageSize && (
                      <CustomPagination
                        pageCount={
                          pageProps?.getStoreOrdersRequest?.request_data
                            ?.response?.totalNumberOfPages
                        }
                        forcePage={
                          pageProps?.getStoreOrdersRequest?.request_data
                            ?.response?.pageNumber - 1
                        }
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={4}
                        renderOnZeroPageCount={null}
                        currentPageNumber={pageNumber}
                      />
                    )}

                    {/* <div className="pagination-wrap to-right">
                                            <div className="prev-page each-page">
                                                <img src={Caret1} alt="" />
                                            </div>
                                            <div className="prev-page each-page active">1</div>
                                            <div className=" each-page">2</div>
                                            <div className=" each-page">3</div>
                                            <div className=" each-page">4</div>
                                            <div className=" each-page">5</div>
                                            <div className="next-page each-page">
                                                <img src={Caret2} alt="" />
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
            )}
            {pageProps.getStoreOrdersRequest.request_status ===
              "GET_VENDOR_ORDERS_FAILURE" && (
              <AlertMsg
                type="error"
                message={pageProps.getStoreOrdersRequest?.request_data.error}
              />
            )}
          </div>
        </div>
      </div>
      {showFilterModal && (
        <FilterModal
          show={showFilterModal}
          onHide={() => setShowFilterModal(false)}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          onSearch={(filters) => {
            setActiveFilters(filters);
            setShowFilterModal(false);
          }}
          onReset={() => {
            setFilterValues({
              selectedStatuses: [],
              fromDate: "",
              toDate: "",
              minTotal: "0",
              maxTotal: "1000",
            });
            setActiveFilters(null);
            setShowFilterModal(false);
            getStoreOrders({
              pageProps,
              payload: `Page=${pageNumber}&Size=${pageSize}`,
            });
          }}
        />
      )}
    </div>
  );
};
